import {SIGN_UP_OPTION, START_UP_GUIDE_OPTION, START_UP_GUIDE_TYPE, START_UP_GUIDES} from "./DataFlowTypes"
import {INTEGRATION_KEY} from "../integration/Constants"

const default_sign_up_options = [
    SIGN_UP_OPTION.ECOM_MANAGEMENT,
    SIGN_UP_OPTION.RUN_BRICK_AND_MORTAR,
    SIGN_UP_OPTION.SELL_B2B,
    SIGN_UP_OPTION.SELL_TO_CUSTOMERS,
    SIGN_UP_OPTION.WEB_AGENCY
]

export const SIGN_UP_OPTIONS = {
    [INTEGRATION_KEY.SHOPIFY]: default_sign_up_options,
    [INTEGRATION_KEY.SHOPIFY_EXPERT_APP]: default_sign_up_options,
}

const shopify_start_up_guide_options = {
    [SIGN_UP_OPTION.ECOM_MANAGEMENT]: [
        START_UP_GUIDE_OPTION.REQUEST_A_QUOTE_FORM,
        START_UP_GUIDE_OPTION.ADD_TO_QUOTE_BUTTON,
        START_UP_GUIDE_OPTION.HIDE_PRICE_ON_PRODUCT,
        START_UP_GUIDE_OPTION.SEND_QUOTES,
        START_UP_GUIDE_OPTION.SEND_INVOICES,
        START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE,
        START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS,
        START_UP_GUIDE_OPTION.ONLINE_PAYMENTS,
        START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS,
        START_UP_GUIDE_OPTION.SCHEDULE_APPOINTMENTS,
        START_UP_GUIDE_OPTION.SELL_ON_SOCIAL_MEDIA,
        START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS,
    ],

    [SIGN_UP_OPTION.RUN_BRICK_AND_MORTAR]: [
        START_UP_GUIDE_OPTION.SEND_QUOTES,
        START_UP_GUIDE_OPTION.SEND_INVOICES,
        START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE,
        START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS,
        START_UP_GUIDE_OPTION.IPAD_FOR_POS_SHOPIFY,
        START_UP_GUIDE_OPTION.ONLINE_PAYMENTS,
        START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS,
        START_UP_GUIDE_OPTION.SCHEDULE_APPOINTMENTS,
        START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS,
    ],
    [SIGN_UP_OPTION.SELL_B2B]: [
        START_UP_GUIDE_OPTION.REQUEST_A_QUOTE_FORM,
        START_UP_GUIDE_OPTION.ADD_TO_QUOTE_BUTTON,
        START_UP_GUIDE_OPTION.HIDE_PRICE_ON_PRODUCT,
        START_UP_GUIDE_OPTION.SEND_QUOTES,
        START_UP_GUIDE_OPTION.SEND_INVOICES,
        START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE,
        START_UP_GUIDE_OPTION.ACCOUNTS_RECEIVABLE,
        START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS,
        START_UP_GUIDE_OPTION.PAYMENT_TERMS,
        START_UP_GUIDE_OPTION.ONLINE_PAYMENTS,
        START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS,
        START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS,
    ],
    [SIGN_UP_OPTION.SELL_TO_CUSTOMERS]: [
        START_UP_GUIDE_OPTION.SEND_QUOTES,
        START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE,
        START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS,
        START_UP_GUIDE_OPTION.ONLINE_PAYMENTS,
        START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS,
        START_UP_GUIDE_OPTION.SELL_ON_SOCIAL_MEDIA,
        START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS,
    ],
    [SIGN_UP_OPTION.WEB_AGENCY]: [
        START_UP_GUIDE_OPTION.REQUEST_A_QUOTE_FORM,
        START_UP_GUIDE_OPTION.ADD_TO_QUOTE_BUTTON,
        START_UP_GUIDE_OPTION.HIDE_PRICE_ON_PRODUCT,
        START_UP_GUIDE_OPTION.SEND_QUOTES,
        START_UP_GUIDE_OPTION.SEND_INVOICES,
        START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE,
        START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS,
        START_UP_GUIDE_OPTION.IPAD_FOR_POS_SHOPIFY,
        START_UP_GUIDE_OPTION.PAYMENT_TERMS,
        START_UP_GUIDE_OPTION.ONLINE_PAYMENTS,
        START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS,
        START_UP_GUIDE_OPTION.SCHEDULE_APPOINTMENTS,
        START_UP_GUIDE_OPTION.SELL_ON_SOCIAL_MEDIA,
        START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS,
    ]
}
export const START_UP_GUIDE_OPTIONS = {
    [INTEGRATION_KEY.SHOPIFY]: shopify_start_up_guide_options,
    [INTEGRATION_KEY.SHOPIFY_EXPERT_APP]: shopify_start_up_guide_options,
}


export const GUIDE_CHECKLIST_OPTIONS: { [key in START_UP_GUIDE_OPTION]: START_UP_GUIDES } = {
    [START_UP_GUIDE_OPTION.REQUEST_A_QUOTE_FORM]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.request_a_quote_form",
            defaultMessage: "How to add a Request a quote form?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6673140,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.request_a_quote_form_article",
                    defaultMessage: "Setup guide",
                },
            },
        ],
    },
    [START_UP_GUIDE_OPTION.ADD_TO_QUOTE_BUTTON]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.add_to_quote_button",
            defaultMessage: "How to add an 'Add to Quote' button?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6673161,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.add_to_quote_form_article",
                    defaultMessage: "Setup guide",
                },
            },
        ],
    },
    [START_UP_GUIDE_OPTION.HIDE_PRICE_ON_PRODUCT]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.hide_prices_on_products",
            defaultMessage: "How to hide prices on products?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6673157,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.hide_prices_on_products_article",
                    defaultMessage: "Setup guide",
                },
            },
        ],
    },
    [START_UP_GUIDE_OPTION.SEND_QUOTES]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.send_quotes",
            defaultMessage: "How to send customized quotes?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6150270,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.send_quotes_article",
                    defaultMessage: "Send quote guide",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.REDIRECT,
                articleID: 0,
                redirectUrl: "/templates/quote-template/listing",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.send_quotes_redirect",
                    defaultMessage: "Set up your template",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.SEND_INVOICES]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.send_invoices",
            defaultMessage: "How to send invoices?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6152033,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.send_invoices_article",
                    defaultMessage: "Send invoice guide",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.REDIRECT,
                articleID: 0,
                redirectUrl: "/templates/invoice-template/listing",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.send_invoices_redirect",
                    defaultMessage: "Set up your template",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.DIGITAL_SIGNATURE]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.digital_signature",
            defaultMessage: "How to capture digital signature?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5767748,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.digital_signature_article",
                    defaultMessage: "E-signature",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.ACCOUNTS_RECEIVABLE]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.accounts_receivable",
            defaultMessage: "How to manage your accounts receivable?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 3628441,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.accounts_receivable_article",
                    defaultMessage: "Account statement automation",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5373706,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.accounts_receivable_article2",
                    defaultMessage: "Ageing report",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.TRACK_OPEN_DEALS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.track_open_deals",
            defaultMessage: "How to keep track of open deals?",
        },
        guides: [],
    },
    [START_UP_GUIDE_OPTION.IPAD_FOR_POS_SHOPIFY]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.ipad_for_pos",
            defaultMessage: "How to use an iPad for my Point of Sale (Shopify POS)?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5992189,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.ipad_for_pos_article",
                    defaultMessage: "Setup guide",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5992992,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.ipad_for_pos_article2",
                    defaultMessage: "Set up POS tiles",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.PAYMENT_TERMS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.payment_terms",
            defaultMessage: "How to add payment terms to certain sales?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.REDIRECT,
                articleID: 0,
                redirectUrl: "/payment-terms/listing",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.payment_terms_redirect",
                    defaultMessage: "Set up payment terms",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.ONLINE_PAYMENTS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.online_payment",
            defaultMessage: "How to receive online payment for an invoice or a quote?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6150682,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.online_payment_article",
                    defaultMessage: "Collect online payments",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.PARTIAL_PAYMENTS_AND_DEPOSITS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.partial_payments_and_deposits",
            defaultMessage: "How to accept partial payments and deposits?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 6150682,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.partial_payments_and_deposits_article",
                    defaultMessage: "Collect payments",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.SCHEDULE_APPOINTMENTS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.schedule_appointments",
            defaultMessage: "How to schedule appointments?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5220795,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.schedule_appointments_article",
                    defaultMessage: "Scheduling guide",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 5187798,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.schedule_appointments_article2",
                    defaultMessage: "Scheduling pages",
                },
            },
            {
                guideType: START_UP_GUIDE_TYPE.REDIRECT,
                articleID: 0,
                redirectUrl: "/calendars/listing",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.schedule_appointments_article2",
                    defaultMessage: "Set up your calendars",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.SELL_ON_SOCIAL_MEDIA]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.sell_on_social_media",
            defaultMessage: "How to sell on social media?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 3882130,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.sell_on_social_media_article",
                    defaultMessage: "Price list guide",
                },
            },
        ]
    },
    [START_UP_GUIDE_OPTION.SEND_SPECIAL_OFFERS]: {
        descriptionMessage: {
            id: "onboarding.guides_checklist_component.send_special_offers",
            defaultMessage: "How to send special offers?",
        },
        guides: [
            {
                guideType: START_UP_GUIDE_TYPE.INTERCOM_ARTICLE,
                articleID: 3882130,
                redirectUrl: "",
                guideLabel: {
                    id: "onboarding.guides_checklist_component.send_special_offers_article",
                    defaultMessage: "Price list guide",
                },
            },
        ]
    },
}



// WEBPACK FOOTER //
// ./src/state/onboarding/DataFlowMaps.ts